export const PUBLICATION_TYPES = [
  { value: 'service_ground_transport', label: 'Servicio terrestre' },
  { value: 'service_security', label: 'Servicio de custodia' },
  { value: 'service_road_assistance', label: 'Servicio de asistencia vial' },
  { value: 'customs_agent', label: 'Agente aduanal' },
  { value: 'freight_forwarder', label: 'Freight forwarder' },
  { value: 'product', label: 'Producto' },
];

export const PUBLICATION_TYPE_VALUES = PUBLICATION_TYPES.map(type => type.value);

const PUBLICATION_TYPE_VALUE_SET = new Set(PUBLICATION_TYPE_VALUES);

export const PUBLICATION_TYPE_LABELS = PUBLICATION_TYPES.reduce((accumulator, type) => {
  accumulator[type.value] = type.label;
  return accumulator;
}, {});

const TYPE_ALIAS_MAP = {
  unit: 'service_ground_transport',
  service: 'service_ground_transport',
  'servicio terrestre': 'service_ground_transport',
  'servicio terrestre / custodia': 'service_ground_transport',
  'servicio custodia': 'service_security',
  'servicio de custodia': 'service_security',
  custodia: 'service_security',
  'servicio de asistencia vial': 'service_road_assistance',
  'asistencia vial': 'service_road_assistance',
  'agente aduanal': 'customs_agent',
  'servicio aduanal': 'customs_agent',
  aduanal: 'customs_agent',
  freight: 'freight_forwarder',
  'freight forwarder': 'freight_forwarder',
  'operador logistico': 'freight_forwarder',
  service_ground_transport: 'service_ground_transport',
  security_service: 'service_security',
  road_assistance_service: 'service_road_assistance',
  customs_service: 'customs_agent',
  customs_agent: 'customs_agent',
  freight_forwarder: 'freight_forwarder',
};

export const PUBLICATION_SERVICE_TYPES = PUBLICATION_TYPES.filter(
  type => type.value !== 'product'
).map(type => type.value);

const PUBLICATION_SERVICE_TYPE_SET = new Set(PUBLICATION_SERVICE_TYPES);

export const DEFAULT_PUBLICATION_TYPE = PUBLICATION_TYPES[0].value;

export const normalizePublicationType = value => {
  if (value === null || value === undefined) {
    return DEFAULT_PUBLICATION_TYPE;
  }

  const raw = String(value).trim();
  if (!raw) {
    return DEFAULT_PUBLICATION_TYPE;
  }

  if (PUBLICATION_TYPE_VALUE_SET.has(raw)) {
    return raw;
  }

  const lower = raw.toLowerCase();
  if (PUBLICATION_TYPE_VALUE_SET.has(lower)) {
    return lower;
  }

  return TYPE_ALIAS_MAP[lower] || raw;
};

export const getPublicationTypeLabel = value => {
  const normalized = normalizePublicationType(value);
  return PUBLICATION_TYPE_LABELS[normalized] || 'Publicacion';
};

export const isProductPublication = value =>
  normalizePublicationType(value) === 'product';

export const isServicePublication = value =>
  PUBLICATION_SERVICE_TYPE_SET.has(normalizePublicationType(value));

export const PUBLICATION_CATEGORY_RULES = {
  ground_transport: ['service_ground_transport'],
  security_service: ['service_security'],
  road_assistance: ['service_road_assistance'],
  customs_agent: ['customs_agent'],
  suppliers: ['product'],
  freight_forwarder: ['freight_forwarder'],
  logistics_operator: [...PUBLICATION_TYPE_VALUES],
};
